export const logoIcon = (
  <svg width="214" height="42" viewBox="0 0 214 42" fill="none">
    <g>
      <path
        d="M46.0915 13.9948C44.9571 11.2221 43.2377 8.74543 41.0585 6.74506C38.8793 4.74469 36.2952 3.27103 33.4942 2.4314C30.6933 1.59176 27.7462 1.4073 24.8675 1.89143C21.9887 2.37557 19.2509 3.51612 16.8533 5.23002V21.8754C16.8548 24.5332 17.7466 27.1087 19.3777 29.1658C21.0087 31.2228 23.2788 32.6348 25.8032 33.1626C28.3277 33.6904 30.9514 33.3016 33.2298 32.062C35.5083 30.8223 37.3014 28.8081 38.3054 26.3606C38.3918 26.1493 38.472 25.9373 38.5459 25.7229L36.8438 23.9666L34.958 22.0207C34.9248 23.6952 34.3239 25.3048 33.2599 26.5695C32.1958 27.8342 30.7358 28.6741 29.1337 28.9432C27.5316 29.2123 25.8888 28.8935 24.4909 28.0423C23.0931 27.191 22.0285 25.8612 21.4824 24.284C20.9363 22.7068 20.9432 20.982 21.5018 19.4095C22.0605 17.8369 23.1356 16.5162 24.5402 15.6768C25.9448 14.8375 27.5901 14.5327 29.19 14.8153C30.7899 15.098 32.2431 15.9502 33.2971 17.224L37.0399 21.0868L39.1094 23.2221C39.1604 22.7751 39.1863 22.3255 39.1872 21.8754C39.1868 19.9735 38.7302 18.1013 37.8583 16.4257C36.9863 14.7502 35.7261 13.3233 34.1899 12.2723C32.6537 11.2213 30.8894 10.5788 29.0542 10.4023C27.219 10.2257 25.3699 10.5205 23.6719 11.2603C23.5093 11.3318 23.349 11.4057 23.1902 11.4844C22.4386 11.8561 21.7301 12.3141 21.0779 12.8496V7.69627C23.2296 6.5738 25.6076 5.99078 28.0187 5.99455C36.5185 5.99455 43.4095 13.1042 43.4095 21.8754C43.4095 30.6466 36.5185 37.7554 28.0187 37.7554C19.519 37.7554 12.6288 30.6458 12.6288 21.8754C12.6238 19.0504 13.3533 16.2758 14.741 13.8406V6.97752C14.5392 7.16758 14.3418 7.36272 14.1488 7.56296C11.6346 10.1593 9.85215 13.4123 8.9921 16.9737C8.13205 20.5351 8.22682 24.2708 9.26627 27.7808C10.3057 31.2909 12.2507 34.4432 14.893 36.9003C17.5353 39.3574 20.7755 41.0268 24.2667 41.7298C27.7578 42.4328 31.3686 42.1428 34.7123 40.8911C38.0561 39.6393 41.0069 37.4728 43.2491 34.6235C45.4912 31.7742 46.9402 28.3493 47.4408 24.7156C47.9415 21.0818 47.4751 17.376 46.0915 13.9948Z"
        fill="url(#paint0_linear_369_1082)"
      />
      <path
        d="M93.7102 27.211H82.4717C82.6273 28.9778 84.3396 30.2306 86.1763 30.2306C87.7952 30.2306 88.9159 29.5239 89.6008 28.5602L93.1498 30.873C91.6867 33.0574 89.2584 34.2781 86.1141 34.2781C81.4443 34.2781 77.584 31.2264 77.584 25.8297C77.584 20.5937 81.2575 17.2529 85.9584 17.2529C90.5348 17.2529 93.7413 20.4973 93.7413 25.9582C93.7413 26.3758 93.7414 26.8255 93.7102 27.211ZM89.0405 23.9345C89.0405 22.2641 88.0131 20.8828 85.9895 20.8828C84.0282 20.8828 82.5962 22.2962 82.4717 23.9345H89.0405Z"
        fill="#28015E"
      />
      <path
        d="M125.072 22.4889C124.263 21.6858 123.08 21.0434 121.835 21.0434C120.87 21.0434 119.904 21.3967 119.904 22.3283C119.904 23.2278 120.745 23.4847 122.737 23.9345C125.103 24.4806 127.687 25.7012 127.687 28.8172C127.687 32.8647 124.232 34.2781 121.056 34.2781C118.535 34.2781 115.92 33.4108 114.301 31.8046L117.165 28.6887C118.068 29.7166 119.469 30.4876 120.963 30.4876C121.804 30.4876 122.8 30.1342 122.8 29.1063C122.8 28.1105 121.835 27.7892 119.718 27.2753C117.57 26.7613 115.204 25.637 115.204 22.6174C115.204 18.7948 118.69 17.2529 121.648 17.2529C123.952 17.2529 126.349 18.0238 127.874 19.5015L125.072 22.4889Z"
        fill="#28015E"
      />
      <path
        d="M74.4209 28.6229L72.5078 26.628C71.9153 27.2486 71.2091 27.7413 70.4302 28.0774C69.6513 28.4136 68.8154 28.5864 67.9712 28.5859C64.4245 28.5859 61.5503 25.588 61.5503 21.8891C61.5503 18.1901 64.4245 15.193 67.9712 15.193C69.5969 15.1919 71.1613 15.8333 72.3429 16.9855L74.2567 14.9899L76.1759 12.9878C74.9099 11.754 73.397 10.8217 71.7439 10.2567C70.0908 9.69175 68.3377 9.50775 66.6082 9.71772C64.8787 9.9277 63.2149 10.5265 61.734 11.472C60.2531 12.4175 58.9913 13.6866 58.0373 15.1899C57.0834 16.6932 56.4606 18.3941 56.2129 20.1728C55.9652 21.9514 56.0985 23.7644 56.6036 25.4841C57.1086 27.2037 57.9731 28.7882 59.136 30.1257C60.2989 31.4632 61.7319 32.5213 63.3341 33.2253C65.5056 34.1821 67.9052 34.4456 70.2232 33.982C72.5413 33.5184 74.6716 32.3488 76.3394 30.6241L74.4209 28.6229Z"
        fill="#28015E"
      />
      <path
        d="M111.936 12.7975V34.2781H106.488V9.54419H106.526L111.936 12.7975Z"
        fill="#28015E"
      />
      <path
        d="M102.429 12.7975V34.2781H96.9805V9.54419H97.0186L102.429 12.7975Z"
        fill="#28015E"
      />
      <path
        d="M176.399 24.6966V34.2781H170.961V25.9205C170.961 24.0501 170.467 22.35 168.522 22.35C166.714 22.35 165.732 23.8719 165.632 25.6772C165.625 25.78 165.622 25.8844 165.622 25.9888V34.2781H160.184V17.224H165.632V20.3255C166.465 18.937 168.258 17.7556 170.401 17.7556C174.818 17.7588 176.399 21.2956 176.399 24.6966Z"
        fill="#28015E"
      />
      <path
        d="M153.415 17.9757C154.372 17.9773 155.312 17.7177 156.139 17.2232V34.2781H150.691V17.224C151.519 17.7182 152.459 17.9776 153.415 17.9757Z"
        fill="#28015E"
      />
      <path
        d="M153.415 15.1657C154.92 15.1657 156.139 13.9073 156.139 12.355C156.139 10.8026 154.92 9.54419 153.415 9.54419C151.911 9.54419 150.691 10.8026 150.691 12.355C150.691 13.9073 151.911 15.1657 153.415 15.1657Z"
        fill="#28015E"
      />
      <path
        d="M140.458 17.3091C138.411 17.3091 136.92 18.1925 136.007 19.1466V12.722L130.597 9.47192H130.559V34.2067H135.322V31.6681C136.318 33.2743 138.342 34.2059 140.396 34.2059C145.066 34.2059 147.774 30.1584 147.774 25.6933C147.774 21.2282 144.973 17.3091 140.458 17.3091ZM142.032 28.4157C141.366 29.1764 140.442 29.6445 139.451 29.7238C138.46 29.8032 137.478 29.4876 136.706 28.8421C136.246 28.4566 135.877 27.9677 135.629 27.4127C135.38 26.8577 135.258 26.2514 135.271 25.6402C135.285 25.0289 135.434 24.429 135.707 23.8863C135.98 23.3436 136.369 22.8725 136.846 22.5091L136.85 22.505C137.625 21.9219 138.582 21.6554 139.537 21.7569C140.491 21.8584 141.375 22.3207 142.018 23.0548C142.662 23.7888 143.019 24.7427 143.022 25.7325C143.025 26.7223 142.672 27.6781 142.032 28.4157Z"
        fill="#28015E"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_369_1082"
        x1="8.41016"
        y1="21.8662"
        x2="47.6361"
        y2="21.8662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#28015E" />
        <stop offset="1" stopColor="#FF00BE" />
      </linearGradient>
    </defs>
  </svg>
)

export const logoMarkIcon = (
  <svg viewBox="0 0 50 42" fill="none">
    <g>
      <path
        d="M46.0915 13.9948C44.9571 11.2221 43.2377 8.74543 41.0585 6.74506C38.8793 4.74469 36.2952 3.27103 33.4942 2.4314C30.6933 1.59176 27.7462 1.4073 24.8675 1.89143C21.9887 2.37557 19.2509 3.51612 16.8533 5.23002V21.8754C16.8548 24.5332 17.7466 27.1087 19.3777 29.1658C21.0087 31.2228 23.2788 32.6348 25.8032 33.1626C28.3277 33.6904 30.9514 33.3016 33.2298 32.062C35.5083 30.8223 37.3014 28.8081 38.3054 26.3606C38.3918 26.1493 38.472 25.9373 38.5459 25.7229L36.8438 23.9666L34.958 22.0207C34.9248 23.6952 34.3239 25.3048 33.2599 26.5695C32.1958 27.8342 30.7358 28.6741 29.1337 28.9432C27.5316 29.2123 25.8888 28.8935 24.4909 28.0423C23.0931 27.191 22.0285 25.8612 21.4824 24.284C20.9363 22.7068 20.9432 20.982 21.5018 19.4095C22.0605 17.8369 23.1356 16.5162 24.5402 15.6768C25.9448 14.8375 27.5901 14.5327 29.19 14.8153C30.7899 15.098 32.2431 15.9502 33.2971 17.224L37.0399 21.0868L39.1094 23.2221C39.1604 22.7751 39.1863 22.3255 39.1872 21.8754C39.1868 19.9735 38.7302 18.1013 37.8583 16.4257C36.9863 14.7502 35.7261 13.3233 34.1899 12.2723C32.6537 11.2213 30.8894 10.5788 29.0542 10.4023C27.219 10.2257 25.3699 10.5205 23.6719 11.2603C23.5093 11.3318 23.349 11.4057 23.1902 11.4844C22.4386 11.8561 21.7301 12.3141 21.0779 12.8496V7.69627C23.2296 6.5738 25.6076 5.99078 28.0187 5.99455C36.5185 5.99455 43.4095 13.1042 43.4095 21.8754C43.4095 30.6466 36.5185 37.7554 28.0187 37.7554C19.519 37.7554 12.6288 30.6458 12.6288 21.8754C12.6238 19.0504 13.3533 16.2758 14.741 13.8406V6.97752C14.5392 7.16758 14.3418 7.36272 14.1488 7.56296C11.6346 10.1593 9.85215 13.4123 8.9921 16.9737C8.13205 20.5351 8.22682 24.2708 9.26627 27.7808C10.3057 31.2909 12.2507 34.4432 14.893 36.9003C17.5353 39.3574 20.7755 41.0268 24.2667 41.7298C27.7578 42.4328 31.3686 42.1428 34.7123 40.8911C38.0561 39.6393 41.0069 37.4728 43.2491 34.6235C45.4912 31.7742 46.9402 28.3493 47.4408 24.7156C47.9415 21.0818 47.4751 17.376 46.0915 13.9948Z"
        fill="url(#paint0_linear_369_1082)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_369_1082"
        x1="8.41016"
        y1="21.8662"
        x2="47.6361"
        y2="21.8662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#28015E" />
        <stop offset="1" stopColor="#FF00BE" />
      </linearGradient>
    </defs>
  </svg>
)

export const homeIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.535 6.91586L11.535 3.02669C10.6325 2.32419 9.36833 2.32419 8.465 3.02669L3.465 6.91586C2.85583 7.38919 2.5 8.11753 2.5 8.88919V15C2.5 16.3809 3.61917 17.5 5 17.5H15C16.3808 17.5 17.5 16.3809 17.5 15V8.88919C17.5 8.11753 17.1442 7.38919 16.535 6.91586Z"
      stroke="#0C001C"
      strokeWidth="1.5"
    />
  </svg>
)

export const reportsIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M7.50013 17.5031H4.99909C3.6178 17.5031 2.49805 16.3834 2.49805 15.0021V4.9979C2.49805 3.61661 3.6178 2.49686 4.99909 2.49686H15.0033C16.3845 2.49686 17.5043 3.61661 17.5043 4.9979V7.49894"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2693 17.2588C12.113 17.4152 11.901 17.5031 11.6799 17.5031H10V15.8232C10 15.6021 10.0879 15.3901 10.2443 15.2338L15.183 10.2909C15.4521 10.0218 15.817 9.87064 16.1976 9.87064C16.5781 9.87064 16.9431 10.0218 17.2122 10.2909V10.2909C17.4815 10.5599 17.6328 10.9249 17.6328 11.3055C17.6328 11.6861 17.4815 12.0511 17.2122 12.3201L12.2693 17.2588Z"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3438 12.1359L15.3696 14.1617"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.808 12.7245L17.5583 13.4748V13.4748C17.9532 13.8705 17.9532 14.5113 17.5583 14.907L16.6504 15.8157"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.70703 9.16629H11.667"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.70703 5.93579H13.3344"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10239 9.2705C5.15994 9.2705 5.2066 9.22384 5.2066 9.16629C5.2066 9.10874 5.15994 9.06208 5.10239 9.06208C5.04483 9.06208 4.99818 9.10874 4.99818 9.16629C4.99818 9.22384 5.04483 9.2705 5.10239 9.2705"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10239 6.04C5.15994 6.04 5.2066 5.99335 5.2066 5.93579C5.2066 5.87824 5.15994 5.83158 5.10239 5.83158C5.04483 5.83158 4.99818 5.87824 4.99818 5.93579C4.99818 5.99335 5.04483 6.04 5.10239 6.04"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.70703 12.3968H9.16597"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10239 12.501C5.15994 12.501 5.2066 12.4544 5.2066 12.3968C5.2066 12.3393 5.15994 12.2926 5.10239 12.2926C5.04483 12.2926 4.99818 12.3393 4.99818 12.3968C4.99818 12.4544 5.04483 12.501 5.10239 12.501"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const testsIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.6706 6.66526V4.16422C16.6706 3.24336 15.9241 2.49686 15.0033 2.49686H4.16541C3.24455 2.49686 2.49805 3.24336 2.49805 4.16422V15.8357C2.49805 16.7566 3.24455 17.5031 4.16541 17.5031H8.33381"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.70703 12.501H9.16597"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.70703 9.16629H9.99965"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.70703 5.93579H13.3344"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5445 9.16629H12.793"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9188 9.16632V12.3193L18.0805 15.7874C18.4007 16.3009 18.4174 16.9476 18.1243 17.477C17.8312 18.0065 17.2743 18.3355 16.6691 18.3368H12.6716C12.0654 18.3376 11.5065 18.0094 11.212 17.4796C10.9175 16.9498 10.9337 16.3018 11.2544 15.7874L13.4161 12.3193V9.16632"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0344 12.501H13.3066"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10239 12.6052C5.15994 12.6052 5.2066 12.5586 5.2066 12.501C5.2066 12.4435 5.15994 12.3968 5.10239 12.3968C5.04483 12.3968 4.99818 12.4435 4.99818 12.501C4.99818 12.5586 5.04483 12.6052 5.10239 12.6052"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10239 9.2705C5.15994 9.2705 5.2066 9.22384 5.2066 9.16629C5.2066 9.10874 5.15994 9.06208 5.10239 9.06208C5.04483 9.06208 4.99818 9.10874 4.99818 9.16629C4.99818 9.22384 5.04483 9.2705 5.10239 9.2705"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10239 6.04C5.15994 6.04 5.2066 5.99335 5.2066 5.93579C5.2066 5.87824 5.15994 5.83158 5.10239 5.83158C5.04483 5.83158 4.99818 5.87824 4.99818 5.93579C4.99818 5.99335 5.04483 6.04 5.10239 6.04"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const cohortIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.0016 8.33262V6.52187C15.0016 6.07969 14.8258 5.65566 14.5131 5.34304L12.1554 2.98539C11.8428 2.67268 11.4188 2.49686 10.9766 2.49686H4.99744C4.07658 2.49686 3.33008 3.24336 3.33008 4.16422V15.8357C3.33008 16.7566 4.07658 17.5031 4.99744 17.5031H8.33216"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0024 6.66526H11.6677C11.2072 6.66526 10.834 6.29201 10.834 5.83158V2.49686"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="10.834"
      y="14.3768"
      width="2.50104"
      height="3.1263"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="13.3359"
      y="10.8337"
      width="2.50104"
      height="6.66944"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="15.8359"
      y="12.7094"
      width="2.50104"
      height="4.79366"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const patientsIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M8.40786 6.79917C9.14009 7.53141 9.14009 8.71859 8.40786 9.45082C7.67562 10.1831 6.48844 10.1831 5.75621 9.45082C5.02397 8.71859 5.02397 7.53141 5.75621 6.79917C6.48844 6.06694 7.67562 6.06694 8.40786 6.79917"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66602 15.4167V4.61749C1.66602 3.67832 2.42768 2.91666 3.36685 2.91666H16.666C17.5868 2.91666 18.3327 3.66249 18.3327 4.58332V15.4167C18.3327 16.3375 17.5868 17.0833 16.666 17.0833H3.33268C2.41185 17.0833 1.66602 16.3375 1.66602 15.4167Z"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7.91667H15.8333"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 11.25H12.5"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0776 13.75C9.93177 13.3841 9.70677 13.0558 9.4176 12.7883V12.7883C8.92844 12.335 8.28677 12.0833 7.6201 12.0833H6.54344C5.87677 12.0833 5.2351 12.335 4.74594 12.7883V12.7883C4.45677 13.0558 4.23177 13.3841 4.08594 13.75"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const settingsIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8181 13.7971L19.867 13.7849C20.535 13.6178 21.0036 13.0176 21.0036 12.3291V11.6706C21.0036 10.982 20.535 10.3818 19.867 10.2148L19.8179 10.2025C19.3087 10.0749 18.8899 9.71356 18.6892 9.22845C18.4884 8.74333 18.5293 8.19178 18.7994 7.74158L18.82 7.70725C19.1788 7.11581 19.0877 6.35586 18.5992 5.86606L18.1335 5.40045C17.6467 4.91354 16.8909 4.82049 16.3004 5.17474L16.2571 5.20075C15.8069 5.47084 15.2554 5.51164 14.7704 5.31074C14.2854 5.10985 13.9243 4.69103 13.7969 4.18174L13.7847 4.13285C13.6177 3.46485 13.0175 2.99625 12.3289 2.99625H11.6704C10.9818 2.99625 10.3816 3.46486 10.2146 4.13287L10.2023 4.18189C10.0747 4.69118 9.7134 5.10991 9.22828 5.31069C8.74316 5.51148 8.19161 5.47058 7.74141 5.20043L7.70706 5.17984C7.11562 4.82104 6.35567 4.9122 5.86588 5.40071L5.40027 5.86631C4.91335 6.35313 4.82025 7.10887 5.17448 7.69931L5.2001 7.74202C5.47025 8.19222 5.51116 8.74378 5.31038 9.2289C5.1096 9.71402 4.69087 10.0754 4.18159 10.203L4.13273 10.2152C3.46474 10.3822 2.99609 10.9824 2.99609 11.6709V12.3295C2.99609 13.0179 3.46447 13.6181 4.13236 13.7851L4.1809 13.7973C4.69026 13.9246 5.10919 14.2856 5.31025 14.7707C5.51131 15.2557 5.47073 15.8072 5.20084 16.2576L5.1749 16.3008C4.82066 16.8912 4.91369 17.647 5.40056 18.1339L5.86621 18.5996C6.35292 19.0865 7.10856 19.1796 7.69891 18.8254L7.74182 18.7996C8.19201 18.5295 8.74358 18.4886 9.2287 18.6894C9.71383 18.8901 10.0752 19.3089 10.2028 19.8181L10.215 19.8671C10.382 20.5351 10.9822 21.0037 11.6708 21.0037H12.3293C13.0178 21.0037 13.6179 20.5353 13.7849 19.8674L13.7971 19.8189C13.9244 19.3095 14.2854 18.8906 14.7704 18.6895C15.2555 18.4885 15.807 18.5291 16.2574 18.799L16.3006 18.8249C16.8911 19.1792 17.6468 19.0861 18.1337 18.5993L18.5994 18.1336C19.0863 17.6469 19.1794 16.8913 18.8252 16.3009L18.7995 16.258C18.5294 15.8078 18.4885 15.2562 18.6893 14.7711C18.8901 14.286 19.3088 13.9247 19.8181 13.7971Z"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="11.9997"
      cy="12.0003"
      r="2.07779"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const helpIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13.25V13C12 12.183 12.505 11.74 13.011 11.4C13.505 11.067 14 10.633 14 9.833C14 8.728 13.105 7.833 12 7.833C10.895 7.833 10 8.728 10 9.833"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.999 16C11.861 16 11.749 16.112 11.75 16.25C11.75 16.388 11.862 16.5 12 16.5C12.138 16.5 12.25 16.388 12.25 16.25C12.25 16.112 12.138 16 11.999 16"
      stroke="#0C001C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const moreIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="#2A292C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
      stroke="#2A292C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
      stroke="#2A292C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const menuIcon = (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M3.5 14H24.5"
      stroke="#1C0142"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 7H24.5"
      stroke="#1C0142"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 21H24.5"
      stroke="#1C0142"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const plusIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 4.16666V15.8333"
      stroke="#95909C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16797 10H15.8346"
      stroke="#95909C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const xIcon = (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
    <g clipPath="url(#clip0_367_1300)">
      <path
        d="M14.25 4.75L4.75 14.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 4.75L14.25 14.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_367_1300">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const injectionIcon = (
  <svg viewBox="0 0 32 32">
    <path d="M24.16 9.207c0.378 0.377 0.378 0.989 0 1.367s-0.685 0.684-0.685 0.684l0.685 0.684c0.755 0.755 0.755 1.979 0 2.735l-10.255 10.253c-0.756 0.756-1.98 0.756-2.735 0l-0.684-0.684-2.734 2.736 1.367 1.367c0.378 0.377 0.378 0.988 0 1.367-0.378 0.377-0.99 0.377-1.367 0l-5.47-5.471c-0.377-0.377-0.377-0.988 0-1.367 0.378-0.377 0.99-0.377 1.367 0l1.367 1.367 2.735-2.734-0.684-0.684c-0.756-0.754-0.756-1.979 0-2.734l10.256-10.254c0.756-0.756 1.979-0.756 2.734 0l0.684 0.684c0 0 0.307-0.307 0.684-0.684 0.378-0.378 0.99-0.378 1.367 0l0.342 0.342 5.47-5.47v1.367l-4.786 4.786 0.342 0.343zM19.374 8.523c-0.377-0.378-0.989-0.378-1.367 0l-2.051 2.051 1.367 1.367-0.684 0.684-1.367-1.367-2.051 2.051 1.367 1.368-0.684 0.684-1.368-1.368-0.684 0.684 2.735 2.734-0.684 0.684-2.735-2.734-2.049 2.049 2.734 2.734-0.684 0.684-2.734-2.734-0.684 0.684c-0.378 0.377-0.378 0.99 0 1.367l4.102 4.102c0.378 0.379 0.99 0.379 1.368 0l10.254-10.254c0.379-0.377 0.379-0.989 0-1.367l-4.101-4.103zM16.64 9.89l0.684-0.684 2.734 2.734-0.684 0.684-2.734-2.734zM16.64 15.359l-2.734-2.735 0.684-0.684 2.734 2.735-0.684 0.684zM9.803 16.727l0.684-0.684 1.367 1.367-0.684 0.684-1.367-1.367zM29.942 9.386c0 0.725-0.588 1.312-1.312 1.312-0.726 0-1.313-0.588-1.313-1.312 0-0.726 1.313-2.708 1.313-2.708s1.312 1.983 1.312 2.708z"></path>
  </svg>
)

export const chevronDownIcon = (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
    <path
      d="M1 1L7 7L13 1"
      stroke="#1C0142"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const graphIcon = (
  <svg width="30" height="31" viewBox="0 0 30 31" fill="none">
    <path
      d="M28.75 7.75L16.875 20.0208L10.625 13.5625L1.25 23.25"
      stroke="#240155"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.25 7.75H28.75V15.5"
      stroke="#240155"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const orderCheckIcon = (
  <svg width="124" height="123" viewBox="0 0 124 123" fill="none">
    <rect
      x="1"
      width="123"
      height="123"
      rx="61.5"
      fill="#9EEB9E"
      fill-opacity="0.1"
    />
    <rect y="9" width="25" height="25" rx="12.5" fill="#E3F6E3" />
    <rect x="81" y="98" width="25" height="25" rx="12.5" fill="#AFDBAF" />
    <path
      d="M21 69.3882L43.7155 92L106 30"
      stroke="#5E9D5E"
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
)
